/*

inside layout/theme.liquid:
  <script src="{{ 'variant-selector.js' | asset_url }}" defer></script>
</head>

inside snippets/product-media-gallery.liquid:
{% assign matched_variant_id = null %}
{% assign media_id = featured_media.id %}
{% for variant in product.variants %}
  {% if variant.featured_media and variant.featured_media.id == media_id %}
    {% assign matched_variant_id = variant.id %}
    {% break %}
  {% endif %}
{% endfor %}
<button
  .
  .
  .
  data-variant-id="{{ matched_variant_id }}"

{% assign matched_variant_id = null %}
{% assign media_id = media.id %}
{% for variant in product.variants %}
  {% if variant.featured_media and variant.featured_media.id == media_id %}
    {% assign matched_variant_id = variant.id %}
    {% break %}
  {% endif %}
{% endfor %}
<button
  .
  .
  .
  data-variant-id="{{ matched_variant_id }}"

inside snippets/product-variant-options.liquid:
{% assign variant_id = null %}
{% for variant in product.variants %}
  {% if variant.option1 == value %}
    {% assign variant_id = variant.id %}
    {% break %}
  {% endif %}
{% endfor %}

*/

document.addEventListener("DOMContentLoaded", function () {
  const thumbnails = document.querySelectorAll('.thumbnail-slider .thumbnail[data-variant-id]');
  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', function () {
      const variantId = this.getAttribute('data-variant-id'); // Shopify variant ID
      if (variantId) {
        const variantInput = document.querySelector(`variant-selects input[type="radio"][data-variant-id="${variantId}"]`);
        if (variantInput) {
            variantInput.checked = true; // Select the radio button
            variantInput.dispatchEvent(new Event('change', { bubbles: true })); // Trigger Shopify's change event
        }
      }
    });
  });
});
